import { Box, Breadcrumbs, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const ComponentTitle = ({ breadcrumbs }) => {
    const theme = useTheme();
    return (
        <Stack spacing={2}>
            <Breadcrumbs
                sx={{
                    "& a": {
                        color: theme.palette.primary.main,
                        fontSize: "1.2rem",
                        textDecoration: "none"
                    },
                    "& a:hover": {
                        color: theme.palette.primary.main,
                        fontSize: "1.2rem",
                        textDecoration: "underline"
                    },
                    "& p": {
                        color: `${theme.palette.text.primary} !important`, fontSize: "1.2rem"
                    }
                }}
                separator={<NavigateNextIcon sx={{ fill: '#dbdbeb99', }} fontSize="small" />}
                aria-label="breadcrumb"
            >
                {breadcrumbs}
            </Breadcrumbs>
        </Stack>
    )
}

export default ComponentTitle
